<template>
  <ul :class="class_name">
    <li v-for="item in mixedItems" :key="item.key" :class="item.class">
      <content-listing-block-card v-if="item.type === 'post'" :title="item.data.title"
        :subheadline="item.data.subheadline" :permalink="item.data.permalink" :image="item.data.image"
        :date="item.data.date" :eventtype="item.data.event_type" :post_type="item.data.post_type"
        :primary_content_format="item.data.primary_content_format" :variation="variation">
      </content-listing-block-card>
      <promo-cta v-else-if="item.type === 'promo'" :promo_cta="promo_cta.promo_cta" :fallback_image_dark="fallback_image_dark" :fallback_image_light="fallback_image_light"></promo-cta>
    </li>
  </ul>
</template>

<script>
import { computed } from "vue";
import ContentListingBlockCard from "./ContentListingBlockCard.vue";
import PromoCta from "./PromoCta.vue";

export default {
  name: "ContentListingBlockGrid",
  components: {
    ContentListingBlockCard,
    PromoCta,
  },
  props: {
    posts: {
      type: Array,
      required: true,
    },
    class_name: {
      type: String,
      required: true,
    },
    add_promo_cta: {
      type: Boolean,
      required: true,
    },
    promo_cta: {
      type: Object,
      required: true,
    },
    fallback_image_dark: {
      type: Object,
      default: () => ({}),
    },
    fallback_image_light: {
      type: Object,
      default: () => ({}),
    },
    ppp: {
      type: Number,
      required: true,
    },
    variation: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const mixedItems = computed(() => {
      const items = [];

      props.posts.forEach((post, index) => {
        // Add the post
        items.push({
          type: 'post',
          data: post,
          key: `post-${post.id}`,
          class: 'image-hover grid canvas-card'
        });

        // Add promo after the third element of each page using ppp
        const positionInPage = (index + 1) % props.ppp;
        if (props.add_promo_cta && positionInPage === 3 && index < props.posts.length - 1) {
          items.push({
            type: 'promo',
            data: null,
            key: `promo-${post.id}`,
            class: 'promo-cta-item canvas-card'
          });
        }
      });

      return items;
    });

    return {
      mixedItems,
    };
  },
};
</script>
